import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GetTableEntriesUpdateGQL, GetTableEntriesUpdateQuery, TableNameEnum } from "../../../graphql/generated";

@Injectable({
    providedIn: 'root'
})
export class TimeStampTableService {
    private readonly getTableEntriesUpdateGQL: GetTableEntriesUpdateGQL = inject(GetTableEntriesUpdateGQL);

    getTableEntriesUpdate(tableName: TableNameEnum, year?: number, period?: string): Observable<{ data?: GetTableEntriesUpdateQuery }> {
        return this.getTableEntriesUpdateGQL.fetch(
            { tableName, year, period },
            { fetchPolicy: "no-cache" }
        ).pipe(
            map(result => ({ data: result.data }))
        );
    }
}
